import { Component, Inject, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators, FormBuilder } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ProjectMasterService } from "src/app/Service/projectmaster/projectmaster.service";
import { IProjectCreateModel, IProjectMasterViewModel, IEnableSimilarProjectViewModel } from "src/app/ViewModel/ProjectMasterModel";
import { StandardOutputModel } from "src/app/ViewModel/StandardOutputModel";
import { CommonService } from 'src/app/Service/Common.service';
import { NotificationService } from "src/app/Service/notification.service";
import { ProjectViewModel } from 'src/app/ViewModel/ProjectModel';
import { ProjectInfoService } from 'src/app/Service/project-info/project-info.service';
import { OrganizationService } from 'src/app/Service/organization/organization.service';
import { ProjectMemberLinkService } from 'src/app/Service/projectMemberLink/project-member-link.service';
import { BusinessGroupModel } from 'src/app/ViewModel/BusinessGroupModel';

@Component({
    selector: 'app-enable-similar-project',
    templateUrl: './Enable_Similar_Project.component.html'
})
export class EnableSimilarProject implements OnInit {
    projStartDate = new Date();
    projEndDate = new Date();
    projectList: any | IProjectMasterViewModel[] = [];
    businessGroups: BusinessGroupModel[] = [];
    FrombusinessGroups: BusinessGroupModel[] = [];
    TobusinessGroups: undefined| BusinessGroupModel[] = [];
    EnableSimProjForm: FormGroup | undefined;
    selectedFromProject: any;
    public actionButtonText: string = "Submit";
    memberId: number | undefined;
    public projectForm: FormGroup = new FormGroup({

        Fromproject: new FormControl(),
        Toproject: new FormControl(),
        TobusinessGroup: new FormControl(),
        FrombusinessGroup: new FormControl(),
    });

    constructor(private _projService: ProjectMasterService,
        public projectMemberLinkService: ProjectMemberLinkService, private _orgService: OrganizationService, private formBuilder: FormBuilder, private projectInfoService: ProjectInfoService, private _commonService: CommonService, public _dialogRef: MatDialogRef<EnableSimilarProject>,
        private _notificationService: NotificationService,
        @Inject(MAT_DIALOG_DATA) public _data: any) {

    }
    /**
     * ngOnInit - Angular Lifecycle hook
     */
    ngOnInit() {
        this.memberId = this._commonService.getLoggedInUserId();
        if (!!this._data.project)
            this.setFormValues();

    }

    FromProjectChange(event: ProjectViewModel) {
        this.FrombusinessGroups=[];        
        this.projectForm.get('FrombusinessGroup')?.setValue("");
        if (this.getFormValue('Fromproject').project_Id)
            this.projectMemberLinkService.getProjectBusinessGroup(this.getFormValue('Fromproject').project_Id).subscribe((response: BusinessGroupModel[]) => {
                this.FrombusinessGroups = response.filter(each => each.is_Active);
                if (!this.FrombusinessGroups || this.FrombusinessGroups.length == 0)
                    this._notificationService.showToast("business group not available against" + this.getFormValue('Fromproject').projCodeDesc, "Warning");
            });
    }

    async ToProjectchange(event: ProjectViewModel) {
        this.TobusinessGroups =[];
        this.projectForm.get('TobusinessGroup')?.setValue("");
        
        if (this.getFormValue('Toproject').project_Id){
        this.TobusinessGroups = await this.projectMemberLinkService.getProjectBusinessGroup(this.getFormValue('Toproject').project_Id).toPromise();
        if (!this.TobusinessGroups || this.TobusinessGroups.length == 0)
        this._notificationService.showToast("business group not available against" + this.getFormValue('Toproject').projCodeDesc, "Warning");
        else
        this.TobusinessGroups = this.TobusinessGroups.filter(each => each.is_Active);
            }
       
    }

    /**
     * Set form values
     */
    setFormValues() {

        this.projectList = this._data.IprojectList;
        for (let i = 0; i < this.projectList.length; i++) {
            this.projectList[i]['projCodeDesc'] = this.projectList[i].project_Code + ' - ' + this.projectList[i].project_Description;
        }
        this.selectedFromProject = this.projectList.filter((x: { project_Id: any; }) => x.project_Id == this._data.project.project_Id)[0];
        this.projectForm.get('Fromproject')?.setValue(this.selectedFromProject);
        this.FromProjectChange(this.selectedFromProject);
    }

    /**
     * Save project
     */
    saveProject() {

        let EnableSimilarProject: IEnableSimilarProjectViewModel = {
            From_Project_Id: this.getFormValue('Fromproject').project_Id,
            To_Project_Id: this.getFormValue('Toproject').project_Id,
            From_Group_Id: this.getFormValue('FrombusinessGroup').group_Id,
            To_Group_Id: this.getFormValue('TobusinessGroup').group_Id,
            Member_Id: this.memberId,
        };

        this._projService.InsertUpdateEnableSimilarProject(EnableSimilarProject).subscribe((res: StandardOutputModel) => {
            if (res.successCode == 200) {
                //if (this._data == null)
                //projMaster.project_Id = +res.result;
                this._dialogRef.close({ response: res, project: EnableSimilarProject });
            }
            else {
                this._dialogRef.close({ response: res });
            }
        }, err => {

        });
    }

    /**
     * Get GroupForm Controls value
     * @param controlName ControlName
     */
    getFormValue(controlName: string): any {
        return this.projectForm.get(controlName)?.value;
    }

    getStartDateValue(selectedText: any) {
        this.projectForm.get('projStartDate')?.setValue(selectedText);
    }

    getEndDateValue(selectedText: any) {
        this.projectForm.get('projEndDate')?.setValue(selectedText);
    }

    /**
     * Close modal dialog
     */
    closeDialog() {
        this._dialogRef.close();
    }
}